module.exports = __webpack_public_path__ + "res/Roboto-BoldCondensedItalic-webfontd41d.eot?55c10a06dca338c56b737c237e910e93";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldCondensedItalic-webfontd41d.eot
// module id = 52
// module chunks = 0